<template>
  <div class="login">
    <h3>携手合作 共赢未来</h3>
    <section>
      <div class="style">
        <span
          :class="{ active: style === LOGIN_STYLE.ACCOUNT }"
          @click="changeLoginStyle(LOGIN_STYLE.ACCOUNT)"
        >
          账号登录
        </span>
        <span
          :class="{ active: style === LOGIN_STYLE.CODE }"
          @click="changeLoginStyle(LOGIN_STYLE.CODE)"
        >
          扫码登录
        </span>
      </div>
      <div class="account" v-if="style === LOGIN_STYLE.ACCOUNT">
        <el-form ref="formRef" :rules="rules" :model="formData">
          <el-form-item prop="username">
            <el-input
              prefix-icon="el-icon-user"
              v-model="formData.username"
              placeholder="请输入账号"
            />
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              prefix-icon="el-icon-lock"
              v-model="formData.password"
              type="password"
              placeholder="请输入密码"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="code" v-else-if="style === LOGIN_STYLE.CODE">
        <div class="qrContainer">
          <header>打开微信扫一扫登录</header>
        </div>
      </div>
      <div :class="{ copyright: true, account: style === LOGIN_STYLE.ACCOUNT }">
        <el-checkbox v-model="confirm">
          <span class="copyright-txt" @click.stop.prevent>
            同意
            <em @click="openAgreement(AGREEMENT_TYPE.SERVICE_PROTOCOL)">
              《服务协议》
            </em>
            和
            <em @click="openAgreement(AGREEMENT_TYPE.PRIVACY_PROTOCOL)">
              《隐私政策》
            </em>
          </span>
        </el-checkbox>
      </div>
      <el-button
        type="primary"
        v-if="style === LOGIN_STYLE.ACCOUNT"
        class="loginBtn"
        @click="loginByAccount"
      >
        登录
      </el-button>
    </section>
    <footer>
      <span @click="onAccountStateChange(ACCOUNT_STATE.REGISTE)">
        注册账号
      </span>
      <span @click="onAccountStateChange(ACCOUNT_STATE.FORGET_PWD)">
        忘记密码？
      </span>
    </footer>
    <Agreement ref="agreementRef" />
  </div>
</template>

<script lang="ts">
import { Vue, Component, Ref, Inject, Emit } from "vue-property-decorator";
import { Form, Message } from "element-ui";
import { useUserStore } from "@/store/user";
import { ACCOUNT_STATE, LOGIN_STYLE } from "@/utils/enums";
import { AGREEMENT_TYPE } from "@/utils/enums";
import Agreement from "./agreement.vue";
import { accountLogin } from "@/api/account";

@Component({
  components: {
    Agreement: () => import("./agreement.vue"),
  },
})
export default class Login extends Vue {
  LOGIN_STYLE = LOGIN_STYLE;
  AGREEMENT_TYPE = AGREEMENT_TYPE;
  ACCOUNT_STATE = ACCOUNT_STATE;

  // style = LOGIN_STYLE.CODE;
  style = LOGIN_STYLE.ACCOUNT;
  confirm = false;

  rules = {
    username: [{ required: true, message: "请输入用户名" }],
    password: [{ required: true, message: "请输入密码" }],
  };

  formData = {
    username: "",
    password: "",
  };

  userStore = useUserStore();

  @Ref() readonly agreementRef!: Agreement;
  @Ref() readonly formRef!: Form;

  @Inject("hideAccount")
  hideAccount: (() => void | undefined) | undefined;

  changeLoginStyle(s: LOGIN_STYLE) {
    if (s !== this.style) {
      this.style = s;
    }
  }

  openAgreement(t: AGREEMENT_TYPE) {
    const agreementRef = this.$refs.agreementRef as Agreement;
    agreementRef.open(t);
  }

  @Emit("onAccountStateChange")
  onAccountStateChange(s: ACCOUNT_STATE) {
    return s;
  }

  /* 登录(用户名密码) */
  async loginByAccount() {
    if (!this.confirm) {
      Message.warning("请先查阅服务协议与隐私协议");
      return;
    }
    const formRef = this.$refs.formRef as Form;
    try {
      const valid = await formRef.validate();

      if (valid) {
        this.formData.username = this.formData.username.trim();
        this.formData.password = this.formData.password.trim();
        const user = await accountLogin(this.formData);
        this.userStore.setUser(user);

        formRef.resetFields();
        this.confirm = false;
        this.hideAccount && this.hideAccount();
      }
    } catch (e) {
      console.log(e);
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  padding-top: 55px;
  text-align: center;

  > h3 {
    text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
    font-size: 36px;
    font-weight: 700;
    background: linear-gradient(0deg, #ff9c1c 20.24%, #ffe978 78.57%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  section {
    margin-top: 27px;

    .style {
      display: flex;
      justify-content: space-between;
      width: 220px;
      margin: 0 auto;
      padding: 0 24px;

      > span {
        color: #f5d587;
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
        margin-bottom: 7px;
        cursor: pointer;

        &.active,
        &:hover {
          display: flex;
          flex-direction: column;
          align-items: center;
          color: #ff7a00;

          &::after {
            content: "";
            width: 20px;
            height: 1px;
            margin-top: 7px;
            background-color: #ff7a00;
          }
        }
      }
    }

    .account {
      margin-top: 20px;
      padding: 0 20px;
    }

    .code {
      .qrContainer {
        margin: 0 auto 14px;
        padding-top: 10px;
        width: 220px;
        height: 248px;
        border-radius: 6px;
        background: #211105;

        > header {
          margin-bottom: 10px;
          color: #f5d587;
          font-size: 14px;
          font-weight: 400;
          line-height: 18px;
        }
      }
    }

    .copyright {
      margin-bottom: 20px;
      &.account {
        text-align: left;
      }

      :deep(.el-checkbox__inner) {
        background-color: unset;
        border: 1px solid #e4c08c;
      }

      .copyright-txt {
        color: #f5d587;
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        line-height: 15px;

        > em {
          color: #ff7a00;
          font-style: normal;
        }
      }
    }

    .loginBtn {
      width: 370px;
      height: 44px;
      margin: 0 auto 74px;
      background-color: #e4c08c;
      border: unset;
      color: #522008;
      font-size: 16px;
      font-weight: 400;
    }
  }

  footer {
    display: flex;
    justify-content: space-between;
    width: 220px;
    margin: 0 auto;

    > span {
      color: #f5d587;
      font-size: 12px;
      font-weight: 400;
      line-height: 15px;
      cursor: pointer;
    }
  }
}
</style>
